import { useQuery } from '@tanstack/react-query';
import { queryKeys, pluginsService } from '@v2/services';

export const useBitwerxOfferingPlugins = (offeringName: string | null) => {
  const query = useQuery({
    queryKey: queryKeys.plugins.byOffering(offeringName!),
    queryFn: () => pluginsService.getOfferingPlugins(offeringName!),
    enabled: !!offeringName?.trim(),
  });

  return {
    plugins: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useBitwerxOfferingPlugins;
